var _path, _line, _path2, _path3, _path4, _path5, _line2, _line3, _line4, _polyline, _path6, _path7, _path8, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThs20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 485.631,
    height: 635.107,
    viewBox: "0 0 485.631 635.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ths_20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.788,104.9c-15.7-1.592-31.826-1.53-46.8,3.4A75.679,75.679,0,0,0,9.609,137.931v27.644s24.934,17.887,52.578,14.635l184.338,26.013s50.9,20.056,91.016,0v-7.588l14.635-15.712,4.709,0.745s4.977-35.552-15.128-41.562c-6.625-1.981-14.365-2.177-21.18-3.209L268.362,131l-65.623-9.934c-31.571-4.81-62.98-9.987-94.588-14.6C104.079,105.864,99.948,105.323,95.788,104.9Z",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 343.739,
    y1: 326.187,
    x2: 348.026,
    y2: 80.438,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.443,645.231c14.9,6.043,37.023,8.9,64.089-5.916V630.1l24.934-21.139,1.292-74.108",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.609,165.576L23.16,585.111s18.971,27.1,54.746,17.345l115.914,21",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.956,655.291c6.927,7.161,24.6,18.8,63.174,5.231l33.336-36.994V608.961",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16,585.111s-6.5,25.476,13.009,31.438c9.754,2.385,18.975,5.179,29.072,5.745,15.736,0.881,30.761,1.706,45.8,6.925l69.434,10.555",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 53.328,
    y1: 76.983,
    x2: 62.827,
    y2: 500.591,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 62.827,
    y1: 78.324,
    x2: 69.047,
    y2: 499.228,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 243.346,
    y1: 104.946,
    x2: 243.346,
    y2: 448.88,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "479.291 263.715 179.053 630.643 128.485 589.254 429.822 220.983",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436.61,327.054s17.437,28.191,51.54,39.889",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528,691.006l43.412,35.533a4.624,4.624,0,0,1,.65,6.507h0l-1.737,2.122a6.592,6.592,0,0,1-9.276.926l-40.367-33.04a6.592,6.592,0,0,1-.926-9.276l1.737-2.122A4.624,4.624,0,0,1,144.528,691.006Z",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M460.9,320.764l27.34,22.377a15.008,15.008,0,0,1,2.108,21.12l-8.22,10.043a6.592,6.592,0,0,1-9.275.929l-40.367-33.04a6.592,6.592,0,0,1-.926-9.276l8.221-10.044A15.008,15.008,0,0,1,460.9,320.764Z",
    transform: "translate(-8.859 -103.228)",
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 424.802,
    y1: 239.927,
    x2: 136.494,
    y2: 588.454,
    fill: "none",
    stroke: "#62b6ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThs20);
export default __webpack_public_path__ + "static/media/ths_20.7232ce68e6f3cd56598bfe869b16d577.svg";
export { ForwardRef as ReactComponent };